import { useNavigate } from 'react-router';
import { Button } from '@mantine/core';
import { useStore } from '@/store';
import { ErrorBoundary } from '@morph-mapper/ui';

export const GlobalErrorBoundary = () => {
  const [userId, jwt] = useStore(({ config: c }) => [c.getUserId(), c.JWT]);
  const navigate = useNavigate();

  const handleHomePage = () => {
    navigate(`/`);
  };

  return (
    <ErrorBoundary
      message="We are working on fixing the issue. In the meantime, we recommend resetting the graph."
      buttons={[
        <Button color="blue" variant="filled" onClick={handleHomePage}>
          Go to Homepage
        </Button>,
      ]}
    />
  );
};
